import { render, staticRenderFns } from "./RolesForm.vue?vue&type=template&id=599ccc8f&scoped=true"
import script from "./RolesForm.vue?vue&type=script&lang=js"
export * from "./RolesForm.vue?vue&type=script&lang=js"
import style0 from "./RolesForm.vue?vue&type=style&index=0&id=599ccc8f&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599ccc8f",
  null
  
)

export default component.exports